import React, { useEffect, useState } from "react";
import ArrowBackIcon from "../../assets/images/Back.svg";
import ProgramCard from "../../common/components/ProgramCard";
import styles from "./index.module.scss";
import mahatria from "../../assets/images/MahatriaSittingImage.png";
import hdb from "../../assets/images/hdb.png";
import axios from "axios";
import { getItemInLocalStorage } from "../../services/localStorage";
import { getCall, getCallHDB } from "../../services/apiService";
import DataGridWithPagination from "../../common/components/DataGridWithPagination";
import { Box, IconButton, Link, Typography } from "@mui/material";
import { DownloadIcon } from "lucide-react";
import documentDownload from "../../assets/images/document-download-icon.svg";
import searchicon from "../../assets/images/search-black-icon.svg";
import CommonTabs from "../../common/components/Tabs";
import backArrow from "../../assets/images/black-left-arrow.svg";
import { alignProperty } from "@mui/material/styles/cssUtils";
import content from "../../types";
import Loader from "../../common/components/Loader";
import { textAlign } from "@mui/system";
import Tooltip from "@mui/material/Tooltip";
interface Program {
  imageUrl: string;
  title: string;
  dates: string;
  time: string;
  lastEntry: string;
  price: string;
  venue: string;
}
const RenderCellWithTooltip: React.FC<{ children: React.ReactNode; value: string | number }> = ({ children, value }) => {
  const cellRef = React.useRef<HTMLSpanElement>(null);
  const [showTooltip, setShowTooltip] = React.useState(false);

  React.useEffect(() => {
    const el = cellRef.current;
    if (el) {
      setShowTooltip(el.scrollWidth > el.clientWidth);
    }
  }, [value, children]);

  return (
    <Tooltip title={showTooltip ? value ?? "" : ""} arrow disableHoverListener={!showTooltip}>
      <span
        ref={cellRef}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          display: "block",
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};
const RegisteredPrograms: React.FC = () => {
  const [programs, setPrograms] = useState<Program[]>([]);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalData, setTotalData] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [loader, setLoader] = useState(false);

  const formatDateWithSuffix = (date) => {
    const day = new Date(date).getDate();
    const month = new Date(date).toLocaleDateString('en-US', { month: 'long' });
    const year = new Date(date).getFullYear();
    return `${day} ${month} ${year}`;
  };

  useEffect(() => {
    if (selectedTab === 0) {
      fetchPrograms();
    }


  }, [currentPage, pageSize, searchText]);
  const fetchPrograms = async () => {
    setLoader(true);
    const seekerData = getItemInLocalStorage("seekerDetails") || {};
    const registeredPrograms = await getCall(`user/${seekerData.id}/registrations?offset=${currentPage - 1}&limit=${pageSize}&searchText=${searchText}&filters=${encodeURIComponent(JSON.stringify({ "programStatus": "completed" }))}`, undefined, false);
    console.log("Registered Programs: abc", registeredPrograms.data.data.data);
    const formattedRegisteredPrograms = registeredPrograms?.data?.data?.data?.map((program) => {

      const subTotal = program.paymentDetails.length > 0 && program?.paymentDetails[0]?.subTotal;
      const invoicePdfUrl = program?.invoiceDetails[0]?.invoicePdfUrl;
      const payment =
        subTotal === undefined || subTotal === null || isNaN(Number(subTotal))
          ? '-'
          : Number(subTotal).toLocaleString("en-IN");
      const invoiceUrl = invoicePdfUrl === undefined || invoicePdfUrl === null ? "-" : invoicePdfUrl;

      return {
        id: program.id,
        programType: program.program.type.name,
        programName: `${program.program.name}- ${program.allocatedProgram.name}`,
        dateDisplay: formatDateWithSuffix(program?.allocatedProgram?.startsAt),
        payment,
        location: program?.allocatedProgram?.venue || 'NA',
        hasAlert: program.hasAlert || false,
        invoiceUrl,
        isHighlighted: program.isHighlighted || false
      };
    });
    console.log("formateed Registered Programs:", formattedRegisteredPrograms);

    setPrograms(formattedRegisteredPrograms || []);
    setTotalData(registeredPrograms?.data?.data?.pagination?.totalRecords || 0);
    setLoader(false);
  };
  const handleBackClick = () => {
    window.history.back();
  };
  const columns = [
    {
      field: 'programType',
      headerName: 'Type',
      width: 150,
      renderCell: (params) => (
        <RenderCellWithTooltip value={params.value}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value}
          </Typography>
        </RenderCellWithTooltip >
      ),
    },
    {
      field: 'programName',
      headerName: 'Program name',
      width: 180,
      renderCell: (params) => (
        <RenderCellWithTooltip value={params.value}>
          <Typography variant="body2" component="span">
            {params.value}
          </Typography>
        </RenderCellWithTooltip>
      ),
    },
    {
      field: 'dateDisplay',
      headerName: 'Date',
      width: 200,
      renderCell: (params) => {
        // const isHighlighted = params.row.isHighlighted;
        return (
          <RenderCellWithTooltip value={params.value}>
            <Typography variant="body2" component="span">
              {params.value}
            </Typography>
          </RenderCellWithTooltip>
        );
      },
    },
    {
      field: 'payment',
      headerName: 'Payment',
      width: 200,
      renderCell: (params) => (
        <RenderCellWithTooltip value={params.value}>
          <Typography variant="body2" sx={{
            textAlign: params.value === '-' ? 'center' : 'left',
            width: '100%',
            display: 'block',
          }}>
            {
              params.value === '-' ? '-' : `INR ${params.value}/-`
            }
          </Typography>
        </RenderCellWithTooltip>
      ),
    },
    {
      field: 'location',
      headerName: 'Location',
      minWidth: 300,
      flex: 1, // This allows the column to take up the remaining space
      renderCell: (params) => (
        <RenderCellWithTooltip value={params.value}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2">
              {params.value}
            </Typography>
            {params.row.hasAlert && (
              <Box
                sx={{
                  width: 240,
                  height: 24,
                  borderRadius: '50%',
                  backgroundColor: '#FFC107',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {/* <WarningIcon sx={{ fontSize: 16, color: 'white' }} /> */}
              </Box>
            )}
          </Box>
        </RenderCellWithTooltip>
      ),
    },
    {
      field: 'downloadInvoice',
      headerName: 'Download invoice',
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        if (!params.row.invoiceUrl) return null;

        return (
          <RenderCellWithTooltip value={params.row.invoiceUrl}>
            <Box sx={{
              display: 'flex',
              justifyContent: params.row.invoiceUrl === '-' ? 'center' : 'flex-end',
              alignItems: 'center',
              width: '100%',
            }}>
              {params.row.invoiceUrl === '-' ? '-' : (
                <IconButton
                  onClick={() => {

                    axios({
                      url: params.row.invoiceUrl,
                      method: 'GET',
                      responseType: 'blob', // Important for binary data
                    }).then((response) => {
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', 'invoice.pdf');
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(url); // Clean up the URL object
                    }).catch((error) => {
                      console.error('Error downloading the file:', error);
                    });
                  }}
                  size="small"
                  sx={{
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <img
                    src={documentDownload}
                    alt="Download Invoice"
                    style={{ width: '20px', height: '20px' }}
                  />
                </IconButton>)}
            </Box>
          </RenderCellWithTooltip>
        );
      },
    },
  ];
  const tabs = [{ label: "Special programs" }, { label: "infinipaths" }];
  const handleTabChange = (newValue: number) => {
    setSelectedTab(newValue);
    setCurrentPage(1);
    setPageSize(10);
    setTotalData(0);
    setSearchText("");
    setIsSearchActive(false);
    if (newValue === 0) {
      fetchPrograms();
    } else {
      setPrograms([]);
    }
  };

  if (loader) {
    <Loader type="large" />;
  }

  return (
    <div className={`app-layout ${styles.container}`}>
      <div className={styles.headerSection}>
        <div className={styles.titleRow}>
          <IconButton onClick={handleBackClick} className={styles.backButton}>
            <img src={backArrow} alt="Back" />
          </IconButton>
          <span className={styles.titleText}>My Programs</span>
        </div>
      </div>
      <div className={styles.subHeader}>
        <div className={styles.tabsContainer}>
          <CommonTabs tabs={tabs} onTabChange={handleTabChange} />
        </div>
        <div className={styles.searchContainer}>
          <div className={styles.searchBox}>
            {isSearchActive && (
              <input
                type="text"
                placeholder="Search by program name"
                className={styles.searchInput}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            )}
            <button className={styles.searchButton} onClick={() => setIsSearchActive(isSearchActive => !isSearchActive)}>
              <img src={searchicon} className={styles.searchIcon}></img>
            </button>
          </div>
        </div>
      </div>

      <DataGridWithPagination headers={columns} programsData={programs} currentPage={currentPage} setCurrentPage={setCurrentPage} pageSize={pageSize} setPageSize={setPageSize} totalData={totalData} onRowClick={() => {
        console.log("Row clicked");
      }}
      />
    </div>
  );
};

export default RegisteredPrograms;
